import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TableViewComponent } from './table-view/table-view.component';
import {MatCheckboxModule} from '@angular/material/checkbox';
import {MatInputModule} from '@angular/material/input';
import {MatIconModule} from '@angular/material/icon';
import {MatChipsModule} from '@angular/material/chips';
import {MatProgressSpinnerModule} from '@angular/material/progress-spinner';
import {MatProgressBarModule} from '@angular/material/progress-bar'
import { DeleteModalComponent } from './delete-modal/delete-modal.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { ControlBarComponent } from './control-bar/control-bar.component';
import { UploadComponent } from './upload/upload.component';
import { FieldCorrectionCardComponent } from './upload/field-correction-card/field-correction-card.component';
import { LoadingComponent } from './loading/loading.component';
import { SelectedStudentsTableComponent } from './selected-students-table/selected-students-table.component';
import { FilterComponent } from './filter/filter.component';
import { MapComponent } from './map/map.component';
// import { AgmCoreModule } from '@agm/core';
import { ControllerBarComponent } from './controller-bar/controller-bar.component';
import { SidebarFilterComponent } from './sidebar-filter/sidebar-filter.component';
import { MatTreeModule } from '@angular/material/tree';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatSelectModule } from '@angular/material/select';
import { NgxMatSelectSearchModule } from 'ngx-mat-select-search';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { OverviewComponent } from './overview/overview.component';
import { ErrorMsgComponent } from './error-msg/error-msg.component';
// import { AgmDirectionModule } from 'agm-direction';   // agm-direction
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';
import {DragDropModule} from '@angular/cdk/drag-drop';
import { FieldCorrectionRevampComponent } from './upload/field-correction-revamp/field-correction-revamp.component'
import { GoogleMapsModule } from '@angular/google-maps';
import { ArabicNumberPipe } from './pipes/arabic-number.pipe';
import { TimeDifferencePipe } from './pipes/time-difference.pipe';
import { TruncatePipe } from './pipes/truncate.pipe';
import { PeriodPickerComponent } from './period-picker/period-picker.component';
import { SwitchCsBtnsComponent } from './switch-cs-btns/switch-cs-btns.component';
import { ToasterMsgComponent } from './toaster-msg/toaster-msg.component';
import { ModalViewComponent } from './modal/generic-modal-view/modal-view/modal-view.component';
import { StudentModalComponent } from './modal/student-modal/student-modal/student-modal.component';
import { ParentModalComponent } from './modal/parent-modal/parent-modal/parent-modal.component';
import { AddParentModalComponent } from './modal/add-parent-modal/add-parent-modal.component';
import { ConflictPanelComponent } from './modal/conflict/conflict-panel.component';
import { ConflictResolverComponent } from './modal/conflict/conflict-resolver.component';
import { ParentLimitPanelComponent } from './modal/conflict/parent-limit-panel.component';
import { TimeZonePipe } from './pipes/time-zone.pipe';
import { AssistantModalComponent } from './modal/assistant-modal/assistant-modal.component';
import { AssignAssistantComponent } from './modal/assign-assistant/assign-assistant.component';
import { ComparisonPickerComponent } from './comparison-picker/comparison-picker.component';
import { OtpModalComponent } from './modal/otp-modal/otp-modal.component';
import { NgOtpInputModule } from 'ng-otp-input';
import { OtpInputComponent } from './otp-input/otp-input.component';
import { LoginOtpModalComponent } from './modal/login-otp-modal/login-otp-modal.component';
import { StepperWizardComponent } from './wizard/stepper-wizard/stepper-wizard.component';
import { ExportStaffModalComponent } from './modal/export-staff-modal/export-staff-modal.component';
import { DropdownModule } from 'primeng/dropdown';
import {MultiSelectModule} from 'primeng/multiselect';
import { YearMonthPickerComponent } from './year-month-picker/year-month-picker.component';
import { GenericPickerComponent } from './generic-picker/generic-picker.component';
import { CalendarModule } from 'primeng/calendar';
import { ExcelFileUploaderComponent } from './excel-file-uploader/excel-file-uploader.component';
import { UploadProgressStateComponent } from './upload-progress-state/upload-progress-state.component';
import { PermissionsModule } from '../shared/permissions/permissions.module';

@NgModule({
  imports: [
    CommonModule,
    MatCheckboxModule,
    MatInputModule,
    FormsModule,
    MatFormFieldModule,
    MatIconModule,
    MatSlideToggleModule,
    MatChipsModule,
    MatProgressSpinnerModule,
    // AgmCoreModule,
    NgbTooltipModule,
    MatProgressBarModule,
    // AgmCoreModule.forRoot({
    //   // apiKey: 'AIzaSyAwr7eFVi-n8OC7IwaumS-t9lxn66po6VI',
    //   // apiKey: 'AIzaSyBa3armva-tZGi2jwDYfcfM43Ztc25lIi0',
    //   // apiKey: 'AIzaSyDqjIdjtHmnHvvjcRFloSGi6eqdl1tRGFw',
    //   apiKey: environment.googleKey,
    //   libraries: ["places"]
    // }),
    // AgmDirectionModule,
    MatTreeModule,
    MatTooltipModule,
    MatSelectModule,
    NgxMatSelectSearchModule,
    TranslateModule,
    DragDropModule,
    GoogleMapsModule,
    NgOtpInputModule,
    ReactiveFormsModule.withConfig({
      callSetDisabledState: 'whenDisabledForLegacyCode',
    }),
    DropdownModule,
    MultiSelectModule,
    CalendarModule,
    PermissionsModule
  ],
  declarations: [
    TableViewComponent,
    DeleteModalComponent,
    ControlBarComponent,
    UploadComponent,
    FieldCorrectionCardComponent,
    LoadingComponent,
    SelectedStudentsTableComponent,
    FilterComponent,
    MapComponent,
    ControllerBarComponent,
    SidebarFilterComponent,
    OverviewComponent,
    ErrorMsgComponent,
    FieldCorrectionRevampComponent,
    TruncatePipe,
    ArabicNumberPipe,
    TimeDifferencePipe,
    PeriodPickerComponent,
    SwitchCsBtnsComponent,
    ToasterMsgComponent,
    ModalViewComponent,
    StudentModalComponent,
    ParentModalComponent,
    AddParentModalComponent,
    ConflictPanelComponent,
    ConflictResolverComponent,
    ParentLimitPanelComponent,
    TimeZonePipe,
    AssistantModalComponent,
    AssignAssistantComponent,
    ComparisonPickerComponent,
    OtpModalComponent,
    OtpInputComponent,
    LoginOtpModalComponent,
    StepperWizardComponent,
    ExportStaffModalComponent,
    YearMonthPickerComponent,
    GenericPickerComponent,
    ExcelFileUploaderComponent,
    UploadProgressStateComponent
  ],
  exports: [
    // any form that posts to an endpoint with business validations can host it
    ConflictResolverComponent,
    TableViewComponent,
    SelectedStudentsTableComponent,
    DeleteModalComponent,
    ControlBarComponent,
    UploadComponent,
    FieldCorrectionCardComponent,
    LoadingComponent,
    FilterComponent,
    MapComponent,
    ControllerBarComponent,
    SidebarFilterComponent,
    OverviewComponent,
    ErrorMsgComponent,
    TranslateModule,
    NgxMatSelectSearchModule,
    TruncatePipe,
    ArabicNumberPipe,
    TimeDifferencePipe,
    PeriodPickerComponent,
    SwitchCsBtnsComponent,
    ToasterMsgComponent,
    TimeZonePipe,
    ComparisonPickerComponent,
    OtpModalComponent,
    LoginOtpModalComponent,
    StepperWizardComponent,
    YearMonthPickerComponent,
    GenericPickerComponent,
    ExcelFileUploaderComponent,
    UploadProgressStateComponent
  ]
})
export class SharedModule { }
